const imp = () => import(/* webpackChunkName: "loadSprite_dh"*/  "../sprite/loadSprite_dh");

const loadMap_dh: { [key: string]: () => Promise<any> } = {
  "Icon-N-Performancesetting": imp,
  "Icon-N-Performancetargetlibrary": imp,
  "Icon-N-Setgoals": imp,
  "Icon-N-Performancesetting-o": imp,
  "Icon-N-Performancetargetlibrary-o": imp,
  "Icon-N-Setgoals-o": imp,
  "Icon-N-Systemhomepage-o": imp,
  "Icon-N-Customportal-o": imp,
  "Icon-N-Customportal": imp,
  "Icon-N-Systemhomepage": imp,
  "Icon-N-Approvalapplication-o": imp,
  "Icon-N-Approvalapplication": imp,
  "Icon-N-Approvalprocess-o": imp,
  "Icon-N-Approverefficiency-o": imp,
  "Icon-N-Approvalprocess": imp,
  "Icon-N-Approverefficiency": imp,
  "Icon-N-Approveusage": imp,
  "Icon-N-Approveusage-o": imp,
  "Icon-N-Comprehensiveapproval-o": imp,
  "Icon-N-Delegatesettings-o": imp,
  "Icon-N-Comprehensiveapproval": imp,
  "Icon-N-Efficiencyofapprovalprocess-o": imp,
  "Icon-N-Efficiencyofapprovalprocess": imp,
  "Icon-N-launch-o": imp,
  "Icon-N-launch": imp,
  "Icon-N-Delegatesettings": imp,
  "Icon-N-Cloudform-o": imp,
  "Icon-N-Cloudstore-o": imp,
  "Icon-N-Cloudform": imp,
  "Icon-N-Cloudstore": imp,
  "Icon-N-Formlist": imp,
  "Icon-N-Formlist-o": imp,
  "Icon-N-Reportcomments-o": imp,
  "Icon-N-Submitforapproval-o": imp,
  "Icon-N-Reportcomments": imp,
  "Icon-N-Submitforapproval": imp,
  "Icon-N-datarecord-o": imp,
  "Icon-N-datarecord": imp,
  "Icon-N-Alreadydone": imp,
  "Icon-N-Alreadydone-o": imp,
  "Icon-N-Closed-o": imp,
  "Icon-N-Closed": imp,
  "Icon-N-Cloudtemplate-o": imp,
  "Icon-N-Cloudtemplate": imp,
  "Icon-N-Commentfeedback-o": imp,
  "Icon-N-Commentfeedback": imp,
  "Icon-N-Completed-o": imp,
  "Icon-N-Completionstatus-o": imp,
  "Icon-N-Completed": imp,
  "Icon-N-Concerned-o": imp,
  "Icon-N-Completionstatus": imp,
  "Icon-N-Concerned": imp,
  "Icon-N-Customfieldstatistics-o": imp,
  "Icon-N-Customfieldstatistics": imp,
  "Icon-N-Departmentstatisticalreport-o": imp,
  "Icon-N-Departmentstatisticalreport": imp,
  "Icon-N-Ishare-o": imp,
  "Icon-N-Ishare": imp,
  "Icon-N-Liststatistics-o": imp,
  "Icon-N-Membershipstatistics-o": imp,
  "Icon-N-Liststatistics": imp,
  "Icon-N-Membershipstatistics": imp,
  "Icon-N-Mysubordinates-o": imp,
  "Icon-N-Mysubordinates": imp,
  "Icon-N-Newlyassigned-o": imp,
  "Icon-N-Newlyassigned": imp,
  "Icon-N-Relatedtome-o": imp,
  "Icon-N-Relatedtome": imp,
  "Icon-N-Returned-o": imp,
  "Icon-N-Returned": imp,
  "Icon-N-Sharedtome-o": imp,
  "Icon-N-Statisticalreport-o": imp,
  "Icon-N-Sharedtome": imp,
  "Icon-N-Statisticalreport": imp,
  "Icon-N-Statistics-o": imp,
  "Icon-N-Statistics": imp,
  "Icon-N-Template-o": imp,
  "Icon-N-Tobeapproved-o": imp,
  "Icon-N-Template": imp,
  "Icon-N-Tobeapproved": imp,
  "Icon-N-Void-o": imp,
  "Icon-N-Void": imp,
  "Icon-N-my-o": imp,
  "Icon-N-my": imp,
  "Icon-N-newlybuild-o": imp,
  "Icon-N-newlybuild": imp,
  "Icon-N-others-o": imp,
  "Icon-N-others": imp,
  "Icon-N-overtime-o": imp,
  "Icon-N-overtime": imp,
  "Icon-N-personal-o": imp,
  "Icon-N-personal": imp,
  "Icon-N-public-o": imp,
  "Icon-N-recyclebin-o": imp,
  "Icon-N-public": imp,
  "Icon-N-recyclebin": imp,
  "Icon-N-setup-o": imp,
  "Icon-N-setup": imp,
  "Icon-N-subscribe-o": imp,
  "Icon-N-subscribe": imp,
  "Icon-N-system-o": imp,
  "Icon-N-system": imp,
  "Icon-N-whole-o": imp,
  "Icon-N-whole": imp,
  "Icon-N-Ganttchart-o": imp,
  "Icon-N-Mindmap-o": imp,
  "Icon-N-Ganttchart": imp,
  "Icon-N-Knowledgemonitoring-o": imp,
  "Icon-N-Knowledgemonitoring": imp,
  "Icon-N-Mindmap": imp,
  "Icon-N-Periodicschedule-o": imp,
  "Icon-N-Periodicschedule": imp,
  "Icon-N-Queryschedule-o": imp,
  "Icon-N-Queryschedule": imp,
  "Icon-N-Schedule-o": imp,
  "Icon-N-Schedulefeedback-o": imp,
  "Icon-N-Schedulefeedback": imp,
  "Icon-N-Schedulemonitoring-o": imp,
  "Icon-N-Teamprojecttemplate-o": imp,
  "Icon-N-Schedule": imp,
  "Icon-N-Virtualknowledgebase-o": imp,
  "Icon-N-Schedulemonitoring": imp,
  "Icon-N-Virtualknowledgebase": imp,
  "Icon-N-Teamprojecttemplate": imp,
  "Icon-N-Weeklyschedule": imp,
  "Icon-N-Weeklyschedule-o": imp,
  "Icon-N-Conferenceroomusage-o": imp,
  "Icon-N-Conferenceroomusage": imp,
  "Icon-N-Corporateticketholder": imp,
  "Icon-N-Conferencemonitoring-o": imp,
  "Icon-N-Deleted-o": imp,
  "Icon-N-Deleted": imp,
  "Icon-N-Enterpriseaccount-o": imp,
  "Icon-N-Enterpriseaccount": imp,
  "Icon-N-Corporateticketholder-o": imp,
  "Icon-N-Conferencemonitoring": imp,
  "Icon-N-Enterpriserise": imp,
  "Icon-N-Inbox-o": imp,
  "Icon-N-Identificationrecord": imp,
  "Icon-N-Inbox": imp,
  "Icon-N-Identificationrecord-o": imp,
  "Icon-N-Inspectionrecord-o": imp,
  "Icon-N-Inspectionrecord": imp,
  "Icon-N-Enterpriserise-o": imp,
  "Icon-N-Serviceprovider-o": imp,
  "Icon-N-Myapplication": imp,
  "Icon-N-Myapplication-o": imp,
  "Icon-N-Serviceprovider": imp,
  "Icon-N-Standardstarmail": imp,
  "Icon-N-Writemail-o": imp,
  "Icon-N-Standardstarmail-o": imp,
  "Icon-N-Writemail": imp,
  "Icon-N-Advancepayment-o": imp,
  "Icon-N-Advancepayment": imp,
  "Icon-N-Billinginformation-o": imp,
  "Icon-N-Causeanalysis-o": imp,
  "Icon-N-Billinginformation": imp,
  "Icon-N-Causeanalysis": imp,
  "Icon-N-Cluepool-o": imp,
  "Icon-N-Cluepool": imp,
  "Icon-N-Collectioninformation-o": imp,
  "Icon-N-Collectioninformation": imp,
  "Icon-N-Collectionmanagement-o": imp,
  "Icon-N-Collectionmanagement": imp,
  "Icon-N-Contactrecord-o": imp,
  "Icon-N-Contactrecord": imp,
  "Icon-N-Contactrecyclebin-o": imp,
  "Icon-N-Contactrecyclebin": imp,
  "Icon-N-Contactreminder-o": imp,
  "Icon-N-Contactreminder": imp,
  "Icon-N-Contractapproval-o": imp,
  "Icon-N-Contractapproval": imp,
  "Icon-N-Copywriting-o": imp,
  "Icon-N-Copywriting": imp,
  "Icon-N-Customerduplicatecheck-o": imp,
  "Icon-N-Customerduplicatecheck": imp,
  "Icon-N-Customerrecyclebin-o": imp,
  "Icon-N-Customerrecyclebin": imp,
  "Icon-N-Customerunitprice-o": imp,
  "Icon-N-Customerunitprice": imp,
  "Icon-N-Deductioninformation-o": imp,
  "Icon-N-Deductioninformation": imp,
  "Icon-N-Defaulthighseas-o": imp,
  "Icon-N-Defaulthighseas": imp,
  "Icon-N-Detailedlist-o": imp,
  "Icon-N-Detailedlist": imp,
  "Icon-N-Earlywarningreport-o": imp,
  "Icon-N-Earlywarningreport": imp,
  "Icon-N-Exchangeratesetting-o": imp,
  "Icon-N-Exchangeratesetting": imp,
  "Icon-N-Inventorycount-o": imp,
  "Icon-N-Inventorycount": imp,
  "Icon-N-Isubmittedit-o": imp,
  "Icon-N-Isubmittedit": imp,
  "Icon-N-Livecode-o": imp,
  "Icon-N-Livecode": imp,
  "Icon-N-Mass-o": imp,
  "Icon-N-Mass": imp,
  "Icon-N-Materialcenter-o": imp,
  "Icon-N-Materialcenter": imp,
  "Icon-N-Officialaccountmessage-o": imp,
  "Icon-N-Officialaccountmessage": imp,
  "Icon-N-Orderintervention-o": imp,
  "Icon-N-Orderintervention": imp,
  "Icon-N-Paymentinformation-o": imp,
  "Icon-N-Paymentinformation": imp,
  "Icon-N-Paymentmanagement-o": imp,
  "Icon-N-Paymentmanagement": imp,
  "Icon-N-Periodinformation-o": imp,
  "Icon-N-Periodinformation": imp,
  "Icon-N-Salescycle-o": imp,
  "Icon-N-Salescycle": imp,
  "Icon-N-Uncommitted-o": imp,
  "Icon-N-Uncommitted": imp,
  "Icon-N-Underapproval-o": imp,
  "Icon-N-Underapproval": imp,
  "Icon-N-anniversariesofimportantevents-o": imp,
  "Icon-N-anniversariesofimportantevents": imp,
  "Icon-N-draft-o": imp,
  "Icon-N-draft": imp,
  "Icon-N-internationalwaters-o": imp,
  "Icon-N-internationalwaters": imp,
  "Icon-N-rule-o": imp,
  "Icon-N-rule": imp,
  "Icon-N-Abnormalattendance-o": imp,
  "Icon-N-Abnormalattendance": imp,
  "Icon-N-Assessmentscheme-o": imp,
  "Icon-N-Assessmentscheme": imp,
  "Icon-N-Attendancereport-o": imp,
  "Icon-N-Attendancereport": imp,
  "Icon-N-Employeeinformation-o": imp,
  "Icon-N-Fieldtrajectory-o": imp,
  "Icon-N-Employeeinformation": imp,
  "Icon-N-Fieldtrajectory": imp,
  "Icon-N-Personnelcontract-o": imp,
  "Icon-N-Personnelcontract": imp,
  "Icon-N-ScoringReport-o": imp,
  "Icon-N-ScoringReport": imp,
  "Icon-N-Workinghours": imp,
  "Icon-N-Workinghours-o": imp,
  "Icon-N-ExternalContacts": imp,
  "Icon-N-Newrule": imp,
  "Icon-N-Personalwelcome": imp,
  "Icon-N-ExternalContacts-o": imp,
  "Icon-N-Newrule-o": imp,
  "Icon-N-Personalwelcome-o": imp,
  "Icon-N-supervise": imp,
  "Icon-N-supervise-o": imp,
  "Icon-N-Data-acquisition": imp,
  "Icon-N-Individualincometaxwithholding": imp,
  "Icon-N-Salary-a-:-C-set": imp,
  "Icon-N-Salary-and-welfare": imp,
  "Icon-N-Salary-file": imp,
  "Icon-N-Salary-item-management": imp,
  "Icon-N-Salaryaccounting": imp,
  "Icon-N-socialsecurity": imp,
  "Icon-N-External-personnel-management": imp,
  "Icon-N-Browse-box-display-field-definition": imp,
  "Icon-N-Browse-box-display-settings": imp,
  "Icon-N-Custom-settings": imp,
  "Icon-N-Matrix-settings": imp,
  "Icon-N-Organization-dimension": imp,
  "Icon-N-Privacy-settings": imp,
  "Icon-N-Personnel-name-setting": imp,
  "Icon-N-Job-information": imp,
  "Icon-N-Job-level-information": imp,
  "Icon-N-Position-information": imp,
  "Icon-N-Organization-chart": imp,
  "Icon-N-Title-Information": imp,
  "Icon-N-Portrait-of-personnel": imp,
  "Icon-N-Team-portrait": imp,
  "Icon-N-Formula-list": imp,
  "Icon-N-Function-list": imp,
  "Icon-N-Rule-base": imp,
  "Icon-N-Attendance": imp,
  "Icon-N-welfare": imp,
  "Icon-N-Personnelchange": imp,
  "Icon-N-Personnelstatus": imp,
  "Icon-N-Personnelstatus02": imp,
  "Icon-N-train": imp,
  "Icon-N-Approvalrecyclebin": imp,
  "Icon-N-Batchprinting": imp,
  "Icon-N-ConferenceScheduler": imp,
  "Icon-N-Resolutiontasks": imp,
  "Icon-N-videoconferencing": imp,
  "Icon-N-Periodicmeetings": imp,
  "Icon-N-Basicinformation": imp,
  "Icon-N-Messagereminder": imp,
  "Icon-N-Jointeamlist": imp,
  "Icon-N-Preferences": imp,
  "Icon-N-Allmessages": imp,
  "Icon-N-Announcementclassification": imp,
  "Icon-N-Cluepool02": imp,
  "Icon-N-entrust": imp,
  "Icon-N-following": imp,
  "Icon-N-library": imp,
  "Icon-N-monitor": imp,
  "Icon-N-Moduleapproval-o": imp,
  "Icon-N-Moduleapproval": imp,
  "Icon-N-All-files": imp,
  "Icon-N-Initiate-signing": imp,
  "Icon-N-To-be-signed-by-the-other-party": imp,
  "Icon-N-To-be-signed-by-us": imp,
  "Icon-N-Signed": imp,
  "Icon-N-Draft-signing": imp,

  "Icon-N-C-set-o": imp,
  "Icon-N-Allmessages-o": imp,
  "Icon-N-All-files-o": imp,
  "Icon-N-Announcementclassification-o": imp,
  "Icon-N-Approvalrecyclebin-o": imp,
  "Icon-N-Attendance-o": imp,
  "Icon-N-Browse-box-display-field-definition-o": imp,
  "Icon-N-Batchprinting-o": imp,
  "Icon-N-Cluepool02-o": imp,
  "Icon-N-Browse-box-display-settings-o": imp,
  "Icon-N-Conference-screen": imp,
  "Icon-N-Conference-screen-o": imp,
  "Icon-N-ConferenceScheduler-o": imp,
  "Icon-N-Custom-settings-o": imp,
  "Icon-N-Data-acquisition-o": imp,
  "Icon-N-External-personnel-management-o": imp,
  "Icon-N-Formula-list-o": imp,
  "Icon-N-Draft-signing-o": imp,
  "Icon-N-Function-list-o": imp,
  "Icon-N-Individualincometaxwithholding-o": imp,
  "Icon-N-Initiate-signing-o": imp,
  "Icon-N-Job-information-o": imp,
  "Icon-N-Matrix-settings-o": imp,
  // "Icon-N-Moduleapproval-o": imp,
  "Icon-N-Organization-chart-o": imp,
  "Icon-N-Organization-dimension-o": imp,
  "Icon-N-Job-level-information-o": imp,
  "Icon-N-Personnel-name-setting-o": imp,
  "Icon-N-Other-permissions-o": imp,
  "Icon-N-Personnelchange-o": imp,
  "Icon-N-Personnelstatus02-o": imp,
  "Icon-N-Periodicmeetings-o": imp,
  "Icon-N-Personnelstatus-o": imp,
  "Icon-N-Position-information-o": imp,
  "Icon-N-Salary-and-welfare-o": imp,
  "Icon-N-Resolutiontasks-o": imp,
  "Icon-N-Portrait-of-personnel-o": imp,
  "Icon-N-Privacy-settings-o": imp,
  "Icon-N-Salary-file-o": imp,
  "Icon-N-Team-portrait-o": imp,
  "Icon-N-Salaryaccounting-o": imp,
  "Icon-N-Signed-o": imp,
  "Icon-N-System-settings-o": imp,
  "Icon-N-To-be-signed-by-the-other-party-o": imp,
  "Icon-N-Title-Information-o": imp,
  "Icon-N-Salary-item-management-o": imp,
  "Icon-N-entrust-o": imp,
  "Icon-N-following-o": imp,
  "Icon-N-library-o": imp,
  "Icon-N-monitor-o": imp,
  "Icon-N-To-be-signed-by-us-o": imp,
  "Icon-N-socialsecurity-o": imp,
  "Icon-N-train-o": imp,
  "Icon-N-Rule-base-o": imp,
  "Icon-N-videoconferencing-o": imp,
  "Icon-N-Basicinformation-o": imp,
  "Icon-N-Jointeamlist-o": imp,
  "Icon-N-Preferences-o": imp,
  "Icon-N-Messagereminder-o": imp,
  "Icon-N-Signatureaudit-o": imp,
  "Icon-N-Templatereview-o": imp,
  "Icon-N-Mailboxerror-o": imp,
  "Icon-N-Receivecachesettings-o": imp,
  "Icon-N-Receivingrules-o": imp,
  "Icon-N-Templatesettings-o": imp,
  "Icon-N-portsettings-o": imp,
  "Icon-N-Approval-exchange-o": imp,
  "Icon-N-function-library-o": imp,
  "Icon-N-Approval-exchange": imp,
  "Icon-N-function-library": imp,
  "Icon-N-Change-budget-filling": imp,
  "Icon-N-Opening-budget-filling": imp,
  "Icon-N-Report-analysis-o": imp,
  "Icon-N-Report-analysis": imp,
  "Icon-N-Opening-budget-filling-o": imp,
  "Icon-N-Change-budget-filling-o": imp,
  "Icon-N-Control-item-settings": imp,
  "Icon-N-Control-item-settings-o": imp,
  "Icon--N-Holiday-management-o": imp,
  "Icon-N-Applet-o": imp,
  "Icon-N-Applet": imp,
  "Icon-N-Customer-service-team-o": imp,
  "Icon--N-Holiday-management": imp,
  "Icon-N-Customer-service-team": imp,
  "Icon-N-Online-session-o": imp,
  "Icon-N-Online-session": imp,
  "Icon-N-Report-sharing-o": imp,
  "Icon-N-Report-sharing": imp,
  "Icon-N-feishu-o": imp,
  "Icon-N-feishu": imp,
  "Icon-N-gateway-o": imp,
  "Icon-N-gateway": imp,
  "Icon-N-government-affairs-o": imp,
  "Icon-N-government-affairs": imp,
  "Icon-robot-o": imp,
  "Icon-N-Intelligent-ticket-review-o": imp,
  "Icon-N-Intelligent-ticket-review": imp,
  "Icon-N-I-initiated-o": imp,
  "Icon-N-I-initiated": imp,
  "Icon-N-I-participated-o": imp,
  "Icon-N-I-participated": imp,
  "Icon-N-New-signature-o": imp,
  "Icon-N-New-signature": imp,
  "Icon-N-Personnel-information-submission": imp,
  "Icon-N-Personnel-information-submission-o": imp,
  "Icon-N-Document-comparison": imp,
  "Icon-N-Document-comparison-o": imp,
  "Icon-N-Salary-adjustment-management": imp,
  "Icon-N-Salary-adjustment-management-o": imp,
}
export default loadMap_dh;

